package ru.villawonka.app.domain.model

data class CityInfoDomain(
    val city: String,
    val districts: List<String>
)